
import { defineComponent, ref, PropType } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { UserProps } from '../store'

export default defineComponent({
  name: 'GlobalHeader',
  props: {
    user: {
      type: Object as PropType<UserProps>,
      required: true
    }
  },
  setup () {
    const router = useRouter()
    const store = useStore()
    const isShowKf = ref(false)
    const logout = () => {
      console.log('退出登录中...')
      store.commit('logout')
      router.push('/login')
    }

    const showKf = () => {
      isShowKf.value = true
    }

    const hideKf = () => {
      isShowKf.value = false
    }

    return {
      isShowKf,
      showKf,
      hideKf,
      logout
    }
  }
})
